<template>
  <header class="header">
    <div class="header-container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/img/logo.png" alt="logo">
        </router-link>
      </div>
      <div class="nav">
        <ul>
          <li v-for="category in categories" :key="category">
            <router-link :to="{ path: '/products', query: { category: category, saleType: 'retail' }}" :class="{ sale: category === 'SALE', active: currentCategory === category }">{{ category }}</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/products', query: { saleType: 'wholesale' }}">批發專區</router-link>
          </li>
        </ul>
      </div>
      <div class="header-icons">
        <div class="search">
          <img src="@/assets/img/search.svg" alt="search">
        </div>
        <div class="cart" @click.stop="toggleCart">
          <img src="@/assets/img/cart.svg" alt="cart">
          <span v-if="cartItemCount > 0" class="cart-count">{{ cartItemCount }}</span>
          <div v-if="isCartOpen" class="cart-popup" @click.stop>
            <div class="cart-header">
              <h3>購物車</h3>
              <button class="close-btn" @click="toggleCart">&times;</button>
            </div>
            <div class="cart-items" v-if="cartItems.length > 0">
              <div v-for="item in cartItems" :key="item.id" class="cart-item">
                <img :src="item.image" :alt="item.name">
                <div class="item-details">
                  <h4>{{ item.name }}</h4>
                  <p class="variant">{{ item.color }} / {{ item.size }}</p>
                  <div class="quantity-price">
                    <div class="quantity">
                      <button @click.stop="decreaseQuantity(item)">-</button>
                      <span>{{ item.quantity }}</span>
                      <button @click.stop="increaseQuantity(item)">+</button>
                    </div>
                    <p class="price">$NTD {{ item.price }}</p>
                  </div>
                </div>
                <button class="remove-btn" @click.stop="removeFromCart(item)">&times;</button>
              </div>
            </div>
            <div v-else class="empty-cart">
              <p>購物車是空的</p>
            </div>
            <div class="cart-footer" v-if="cartItems.length > 0">
              <div class="total">
                <span>總計:</span>
                <span>$NTD {{ total }}</span>
              </div>
              <router-link to="/checkout/cart" class="checkout-btn" @click="toggleCart">
                前往結帳
              </router-link>
            </div>
          </div>
        </div>
        <div class="user">
          <img src="@/assets/img/user.svg" alt="user">
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      isCartOpen: false
    }
  },
  computed: {
    ...mapState(['categories', 'cartItems']),
    cartItemCount() {
      return this.cartItems.reduce((total, item) => total + item.quantity, 0)
    },
    total() {
      return this.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0)
    },
    currentCategory() {
      return this.$route.query.category
    }
  },
  methods: {
    ...mapMutations(['removeFromCart', 'updateCartItemQuantity']),
    toggleCart(event) {
      if (event) {
        event.stopPropagation()
      }
      this.isCartOpen = !this.isCartOpen
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        this.updateCartItemQuantity({ 
          item: {
            id: item.id,
            color: item.color,
            size: item.size
          }, 
          quantity: item.quantity - 1 
        })
      }
    },
    increaseQuantity(item) {
      this.updateCartItemQuantity({ 
        item: {
          id: item.id,
          color: item.color,
          size: item.size
        }, 
        quantity: item.quantity + 1 
      })
    },
    getImageUrl(imageName) {
      try {
        return require(`@/assets/img/${imageName}`)
      } catch (e) {
        console.error('Image not found:', imageName)
        return ''
      }
    }
  },
  mounted() {
    // 點擊頁面其他地方時關閉購物車
    document.addEventListener('click', () => {
      this.isCartOpen = false
    })
  },
  beforeDestroy() {
    // 移除事件監聽器
    document.removeEventListener('click', () => {
      this.isCartOpen = false
    })
  }
}
</script>

<style scoped>
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background: #fff;
    z-index: 1000;
}

.header .header-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header .header-container .logo {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.header .header-container .logo img {
    height: 40px;
}

.header .header-container .logo span {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
}

.header .header-container .nav ul {
    display: flex;
    list-style: none;
    gap: 2rem;
}

.header .header-container .nav a {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    transition: color 0.3s;
}

.header .header-container .nav a:hover {
    color: #666;
}

.header .header-container .nav a.sale {
    color: #FF4D4D;
}

.header .header-container .nav a.active {
    color: #F99393;
}

.header .header-container .header-icons {
    display: flex;
    gap: 2rem;
}

.header .header-container .icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    transition: transform 0.3s;
}

.header .header-container .icon-btn:hover {
    transform: scale(1.1);
}

.cart {
  position: relative;
}

.cart-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #FF0000;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 50%;
  min-width: 18px;
  text-align: center;
}

.cart-popup {
  position: absolute;
  top: 100%;
  right: 0;
  width: 400px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  margin-top: 1rem;
  padding: 1rem;
}

.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #E5E5E5;
}

.cart-header h3 {
  margin: 0;
  font-size: 1.2rem;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.cart-items {
  max-height: 400px;
  overflow-y: auto;
}

.cart-item {
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid #E5E5E5;
}

.cart-item img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
}

.item-details {
  flex: 1;
}

.item-details h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #333;
}

.variant {
  color: #666;
  font-size: 0.9rem;
  margin: 0 0 0.5rem 0;
}

.quantity-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.quantity {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quantity button {
  width: 24px;
  height: 24px;
  border: 1px solid #E5E5E5;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}

.quantity span {
  min-width: 20px;
  text-align: center;
}

.price {
  font-weight: 500;
  color: #333;
  margin: 0;
}

.remove-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #999;
  cursor: pointer;
  padding: 0.5rem;
}

.empty-cart {
  text-align: center;
  padding: 2rem 0;
  color: #666;
}

.cart-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #E5E5E5;
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-weight: 500;
}

.checkout-btn {
  display: block;
  width: 100%;
  padding: 0.8rem;
  background: #F99393;
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.checkout-btn:hover {
  background: #9B7629;
}
</style> 